<template>
    <div class="ui segment">
      <h4 class="ui header">{{ getHeader() }}</h4>
      <div class="ui form">
        <div class="field" v-if="authenticated">
          <div class="ui selection dropdown contact-type">
              <input v-on:change="selectSaved" type="hidden" name="saved-contact" value="new">
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu">
                <div class="item" data-value="new">Create new contact...</div>
                <div v-for="(contact, index) in savedContacts" v-bind:key="index" class="item" :data-value="index">{{contact.firstName}} {{contact.lastName}}</div>
            </div>
          </div>
        </div>

        <div class="fields">
          <div class="eight wide field" v-bind:class="{ disabled: selectedContact !== 'new' }">
            <label>First Name</label>
            <input v-on:change="checkForComplete()" v-model="firstName" type="text" name="first-name">
          </div>
          <div class="eight wide field" v-bind:class="{ disabled: selectedContact !== 'new' }">
              <label>Last Name</label>
              <input v-on:change="checkForComplete()" v-model="lastName" type="text" name="last-name">
          </div>
        </div>

        <div class="field" v-bind:class="{ disabled: selectedContact !== 'new' }">
          <label>Email Address</label>
          <input v-on:change="checkForComplete()" v-model="email" type="text" name="email">
        </div>

        <div class="field" v-bind:class="{ disabled: selectedContact !== 'new' }">
          <label>Phone Number</label>
          <imask-input
            v-on:change="checkForComplete()"
            v-model="phone"
            :mask="'(000) 000-0000'"
            :lazy="true"
            radix="."
          />
        </div>
        <div class="two fields">
          <div class="inline field"  v-bind:class="{ disabled: selectedContact !== 'new' }">
            <div class="ui checkbox">
              <input v-on:change="checkForComplete()" type="checkbox" checked="" tabindex="0" class="hidden" v-model="smsEnabled">
              <label>Allow text messages for this number</label>
            </div>
          </div>

          <div class="inline field" v-if="authenticated && selectedContact === 'new'">
            <div class="ui checkbox">
              <input v-on:change="checkForComplete()" type="checkbox" checked="" tabindex="0" class="hidden" v-model="saveAddress">
              <label>Save this address</label>
            </div>
          </div>
        </div>
        <!-- <div class="field" v-on:change="$emit('contactType', $event.target.value)" v-if="!passenger">
            <label>I am booking this reservation for...</label>
            <div class="ui selection dropdown contact-type">
                <input type="hidden" name="contact-type" value="passenger">
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="passenger">Myself</div>
                  <div class="item" data-value="arranger">Another Party</div>
              </div>
            </div>
          </div> -->
      </div>
    </div>
</template>

<script>
  import {IMaskComponent} from 'vue-imask'
  import {twosteau} from './mixins/clients/twosteau.js'

  export default {
    name: 'Contact',
    mixins: [twosteau],
    props: {
      passenger: Boolean,
      authenticated: Boolean
    },
    data: function () {
      return {
        contact: {},
        complete: false,
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        smsEnabled: true,
        saveAddress: false,
        anotherMask: Number,
        phoneMask: {
          mask: '(000) 000-0000',
          lazy: true
        },
        savedContacts: [],
        selectedContact: 'new'
      }
    },
    components: {
      'imask-input': IMaskComponent
    },
    methods: {
      checkEmail: function (email) {
        var matches = email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        return matches !== null && matches.length > 0
      },
      checkForComplete: function () {
        console.log(this.phone.length)
        var values = [
          this.firstName !== '',
          this.lastName !== '',
          this.phone.length === 14,
          this.checkEmail(this.email)
        ]
        var result = values.find(function (v) {
          return v === false
        })
        console.log(values)
        return this.$emit('contactComplete', { complete: (result !== false),
          contact: {
            firstName: this.firstName,
            lastName: this.lastName,
            company: '',
            email: this.email,
            phone: this.phone,
            smsEnabled: this.smsEnabled,
            saved: this.saveAddress,
            type: this.getType()
          }
        })
      },
      getType: function () {
        // if (this.passenger) {
        //   return 'PASSENGER'
        // } else {
        //   return 'ARRANGER'
        // }
        return 'PASSENGER'
      },
      getHeader: function () {
        var headers = {
          PASSENGER: 'Passenger Information',
          ARRANGER: 'Contact Information'
        }
        return headers[this.getType()]
      },
      phoneAccept: function (e) {
        this.phone = e.detail.unmaskedValue
        this.checkForComplete()
      },
      getIdToken: function () {
        return localStorage.id_token
      },
      selectSaved: function (e) {
        this.selectedContact = e
        if (e.target.value !== 'new') {
          this.selectedContact = this.savedContacts[Number(e.target.value)]
          this.firstName = this.selectedContact.firstName
          this.lastName = this.selectedContact.lastName
          this.email = this.selectedContact.email
          this.phone = this.selectedContact.phone
          this.smsEnabled = this.selectedContact.snsEnabled
        } else {
          this.selectedContact = 'new'
        }
        this.checkForComplete()
      }
    },
    mounted () {
      $(document)
        .ready(function () {
          $('.dropdown').dropdown()
          $('.ui.checkbox').checkbox()
        })
      this.getSavedContacts(this.getIdToken())
      this.$on('contactsReceived', function (data) {
        this.savedContacts = data
      })
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Contact.vue